
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");
var par = require("par");

module.exports = Model({
	name: "managedmanagerinvites",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_requests: [],
	_managee: null,
	_group: null,
	track: track,
	refresh: refresh,
});

function init() {
	this._who_tracker = this.dispatcher.createTracker();
	this.push([]);
}

function uninit() {
	this._who_tracker.off();
	this._who_tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh
	};
}

function triggers() {
	return {
		"view": view,
		"cancel": handle_remove,
		"reset": reset
	};
}

function view(data) {
	var managee = data.managee;
	this._managee = managee;
	const group = data.group;
	this._group = group;

	this.track(managee);
	this.refresh();
}

function track(managee) {
	if (!managee) {
		console.log("Must provide managee and manager");
		return;
	}

	// Create a tracker for the managee's outgoing requests and their status
	var tracker = this._who_tracker;
	var group = this._group;
	tracker.off();

	if(group){
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/manage/invite/new", handle_add.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/manage/invite/used", par(handle_remove.bind(this), managee));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/manage/invite/cancelled", par(handle_remove.bind(this), managee));
	} else {
		tracker.on("mqtt:u/" + managee + "/manage/invite/new", handle_add.bind(this));
		tracker.on("mqtt:u/" + managee + "/manage/invite/used", par(handle_remove.bind(this), managee));
		tracker.on("mqtt:u/" + managee + "/manage/invite/cancelled", par(handle_remove.bind(this), managee));
	}
}

function handle_remove(data) {
	var invite = data._id;
	this.push(this.data.filter(function(request) {
		return request._id !== invite;
	}));
	this.emit("usermetrics:trigger:track", "cancel managed user's manager invite", {
		who: invite,
	});
}

function handle_add(data) {
	this.push(this.data.concat(data));
}

function reset () {
	this.push([]);
}

function refresh() {
	var managee = this._managee;
	if (!managee) return;
	const group = this._group;

	return this.api.manage.manage.invite.list(managee, group)
		.then(this.push.bind(this))
		.catch(console.error.bind(console));
}
